import React, { useEffect, useState } from "react";
import { startTransition } from "react";
import { useParams } from "react-router-dom";
import { UniqueUser  } from "../../types";
// import { fetchUniqueInfraUserByUserId as fetchUniqueInfraUserDetailByUserId, fetchUserById } from "../../services/api";
import { fetchUniqueInfraUserDetailByEmail, fetchLicensesForUserId, getAllTools, addLicensesToUsers, getLicServers, getInfraServers, disableLicensesFromUniqueUserDetails, enableLicensesFromUniqueUserDetails, requestLicenseExtension, deleteLicensesFromDatabase, getLicenseHistory, getUserIdWithMultipleEmails, generateNfsHome } from "../../services/api";
import { LicenseTransactionEntity } from "../../types";
import { useSidebar } from '../../contexts/SidebarContext';
import { useTranslation } from '../../locales/useTranslation';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import { useNewGui } from '../../hooks/useNewGui';

export const UniqueUserDetails: React.FC = () => {

    // const { userId } = useParams<{ userId: string }>();
    const { email } = useParams<{ email: string }>();
    const { isSidebarOpen } = useSidebar(); // Get sidebar state
    const useNew = useNewGui();
    const t = useTranslation();
  const [user, setUser] = useState<UniqueUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [tools, setTools] = useState<any[]>([]);
  const [toolsLoading, setToolsLoading] = useState<boolean>(true);
  const [selectedTools, setSelectedTools] = useState<string[]>([]);
  const [numLicenses, setNumLicenses] = useState<number>(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedLicenses, setSelectedLicenses] = useState<any[]>([]);
  const [licenseServers, setLicenseServers] = useState<any[]>([]);
  const [infraServers, setInfraServers] = useState<any[]>([]);
  const [selectedServer, setSelectedServer] = useState<string | null>(null);
  const [selectedLicServer, setSelectedLicServer] = useState<string | null>(null);
  const [licenseEndDate, setLicenseEndDate] = useState<Date | null>(null);

  // Operation handling state
  const [operationLoading, setOperationLoading] = useState(false);
  const [operationMessage, setOperationMessage] = useState('');
  const [nfsHomeLoading, setNfsHomeLoading] = useState(false);
  const [nfsHomeMessage, setNfsHomeMessage] = useState('');
  const [extensionModalVisible, setExtensionModalVisible] = useState(false);
  const [extensionDate, setExtensionDate] = useState<Date | null>(null);
  const [extensionRemarks, setExtensionRemarks] = useState('');

  // License addition loading state
  const [addLicenseLoading, setAddLicenseLoading] = useState(false);
  const [addLicenseMessage, setAddLicenseMessage] = useState('');

  // Helper function for consistent result display timing
  const showResultAndHide = (message: string, isSuccess: boolean) => {
    setAddLicenseMessage(message);
    console.log('Add License Result:', message);

    const duration = isSuccess ? 2000 : 4000; // Success: 2s, Error: 4s

    setTimeout(() => {
      setAddLicenseLoading(false);
      setAddLicenseMessage('');
    }, duration);
  };

  // License History Modal states
  const [showLicenseHistory, setShowLicenseHistory] = useState(false);
  const [selectedLicenseHistory, setSelectedLicenseHistory] = useState<any[]>([]);
  const [selectedLicenseSummary, setSelectedLicenseSummary] = useState<any>(null);

  // User-ids linked to more than one email (for warning highlight)
  const [userIdsWithMultipleEmails, setUserIdsWithMultipleEmails] = useState<string[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    const loadUser = async () => {
      try {
        if (email) {
          console.log("Fetching unique user individual details for email ID:", email);
        //   const data = await fetchUserById(userId);
        const data = await fetchUniqueInfraUserDetailByEmail(email);
        console.log("Data in UniqueUserDetails",data)
          if ( data ) {
            setUser(data);
            // console.log("Data in UniqueUserDetails",data)
          }
        }
      } catch (error) {
        console.error("Error fetching unique user individual details:", error);
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [email]);

  useEffect(() => {
    getUserIdWithMultipleEmails().then(setUserIdsWithMultipleEmails);
  }, []);

const [licenses, setLicenses] = useState<any[]>([]);

useEffect(() => {
    const loadLicenses = async () => {
        try {
            if (user?.userId) {
                console.log("Fetching licenses for user ID:", user.userId);
                const licensesData = await fetchLicensesForUserId(user.userId);
                console.log("Licenses Data:", licensesData);
                if (licensesData) {
                    setLicenses(Array.isArray(licensesData) ? licensesData : []);
                }
            }
        } catch (error) {
            console.error("Error fetching licenses:", error);
        }
    };

    loadLicenses();
}, [user]);

useEffect(() => {
    const loadTools = async () => {
        try {
            console.log("Fetching available tools for UniqueUserDetails");
            setToolsLoading(true);
            const toolsData = await getAllTools();
            console.log("Tools Data for UniqueUserDetails:", toolsData);
            if (toolsData && Array.isArray(toolsData)) {
                // Transform tools data to MultiSelect format
                const toolOptions = toolsData.map((tool: any) => ({
                    label: tool.name,
                    value: tool.name
                }));
                setTools(toolOptions);
                console.log("Transformed tools options:", toolOptions);
            } else {
                console.warn("Tools data is not an array or is empty:", toolsData);
                setTools([]);
            }
        } catch (error) {
            console.error("Error fetching tools for UniqueUserDetails:", error);
            setTools([]);
        } finally {
            setToolsLoading(false);
        }
    };

    loadTools();
}, []);

useEffect(() => {
    const loadLicenseServers = async () => {
        try {
            console.log("Fetching available license servers for license allocation");
            const servers = await getLicServers({});
            if (servers) {
                console.log("License servers loaded:", servers);
                setLicenseServers(servers);
            } else {
                console.warn("No license servers returned from API");
                setLicenseServers([]);
            }
        } catch (error) {
            console.error("Error fetching license servers:", error);
            setLicenseServers([]);
        }
    };

    loadLicenseServers();
}, []);

useEffect(() => {
    const loadInfraServers = async () => {
        try {
            console.log("Fetching available infrastructure servers for license allocation");
            const servers = await getInfraServers();
            if (servers) {
                console.log("Infra servers loaded:", servers);
                setInfraServers(servers);
            } else {
                console.warn("No infra servers returned from API");
                setInfraServers([]);
            }
        } catch (error) {
            console.error("Error fetching infra servers:", error);
            setInfraServers([]);
        }
    };

    loadInfraServers();
}, []);

useEffect(() => {
    // Set default license end date to 3 months from now
    const threeMonthsFromNow = new Date();
    threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);
    setLicenseEndDate(threeMonthsFromNow);
}, []);

  // Handler functions for license operations
  const handleDisableLicenses = async () => {
    if (selectedLicenses.length === 0) {
      setOperationMessage('Please select licenses to disable');
      return;
    }

    setOperationLoading(true);
    setOperationMessage('');

    try {
      const licenseIds = selectedLicenses.map(lic => lic.id);
      const result = await disableLicensesFromUniqueUserDetails(licenseIds);

      if (result && result.success !== false) {
        setOperationMessage(`Successfully disabled ${selectedLicenses.length} license(s)`);

        // Refresh license data
        const licensesData = await fetchLicensesForUserId(user!.userId);
        if (licensesData) {
          setLicenses(Array.isArray(licensesData) ? licensesData : []);
        }

        // Clear selection
        setSelectedLicenses([]);
      } else {
        setOperationMessage('Failed to disable licenses');
      }
    } catch (error) {
      console.error('Error disabling licenses:', error);
      setOperationMessage('Error disabling licenses');
    } finally {
      setOperationLoading(false);
    }
  };

  const handleEnableLicenses = async () => {
    if (selectedLicenses.length === 0) {
      setOperationMessage('Please select licenses to enable');
      return;
    }

    setOperationLoading(true);
    setOperationMessage('');

    try {
      const licenseIds = selectedLicenses.map(lic => lic.id);
      const result = await enableLicensesFromUniqueUserDetails(licenseIds);

      if (result && result.success !== false) {
        setOperationMessage(`Successfully enabled ${selectedLicenses.length} license(s)`);

        // Refresh license data
        const licensesData = await fetchLicensesForUserId(user!.userId);
        if (licensesData) {
          setLicenses(Array.isArray(licensesData) ? licensesData : []);
        }

        // Clear selection
        setSelectedLicenses([]);
      } else {
        setOperationMessage('Failed to enable licenses');
      }
    } catch (error) {
      console.error('Error enabling licenses:', error);
      setOperationMessage('Error enabling licenses');
    } finally {
      setOperationLoading(false);
    }
  };

  const handleGenerateNfsHome = async () => {
    if (!user?.userId) return;
    setNfsHomeLoading(true);
    setNfsHomeMessage('');
    try {
      const result = await generateNfsHome(user.userId);
      setUser({
        ...user,
        homePath: result.homePath,
        homeReady: result.homeReady,
        homeProvisionedAt: result.homeProvisionedAt,
        uidNumber: result.uidNumber,
        gidNumber: result.gidNumber,
      });
      const idSuffix = result.uidNumber !== undefined ? ` (uid=${result.uidNumber})` : '';
      let msg: string;
      if (!result.ipaSimulated && !result.homeSimulated) {
        msg = `NFS home ready: ${result.homePath}`;
      } else if (!result.ipaSimulated && result.homeSimulated) {
        msg = `IPA user confirmed${idSuffix}. NFS home creation is still simulated — pending NFS host confirmation (${result.homePath}). See IC-040.`;
      } else {
        msg = `Simulated success — no real IPA/NFS calls yet (${result.homePath}). See IC-040.`;
      }
      setNfsHomeMessage(msg);
    } catch (error: any) {
      console.error('Error generating NFS home:', error);
      setNfsHomeMessage(error?.response?.data?.message || 'Failed to generate NFS home');
    } finally {
      setNfsHomeLoading(false);
    }
  };

  const handleRequestExtension = () => {
    if (selectedLicenses.length === 0) {
      setOperationMessage('Please select licenses to extend');
      return;
    }
    console.log('=== FRONTEND EXTENSION DIALOG OPENED ===');
    console.log('Selected licenses for extension:', selectedLicenses.map(lic => ({ id: lic.id, toolName: lic.toolName, userId: lic.userId })));
    setExtensionModalVisible(true);
  };

  const submitExtensionRequest = async () => {
    console.log('=== FRONTEND EXTENSION REQUEST SUBMISSION ===');

    if (!extensionDate) {
      console.log('Validation failed: No extension date selected');
      setOperationMessage('Please select an extension date');
      return;
    }

    setOperationLoading(true);
    setOperationMessage('');

    const licenseIds = selectedLicenses.map(lic => lic.id);
    console.log('Selected license IDs:', licenseIds);
    console.log('Extension date:', extensionDate.toISOString());
    console.log('Remarks:', extensionRemarks);

    const requestData = {
      licenseIds: licenseIds,
      extensionDate: extensionDate.toISOString(),
      source: "Gui-UniqueUserDetails",
      remarks: extensionRemarks
    };

    console.log('Sending request data to API:', requestData);

    try {
      console.log('Calling requestLicenseExtension API...');
      const result = await requestLicenseExtension(requestData);

      console.log('API Response received:', result);

      if (result && result.success !== false) {
        console.log(`Extension request successful: ${selectedLicenses.length} licenses`);
        setOperationMessage(`Extension request submitted for ${selectedLicenses.length} license(s)`);
        setExtensionModalVisible(false);
        setSelectedLicenses([]);
        setExtensionDate(null);
        setExtensionRemarks('');
      } else {
        console.log('Extension request failed');
        setOperationMessage('Failed to submit extension request');
      }
    } catch (error) {
      console.error('=== FRONTEND EXTENSION REQUEST ERROR ===');
      console.error('Error details:', error);
      setOperationMessage('Error submitting extension request');
    } finally {
      setOperationLoading(false);
    }
  };

  const handleRemoveLicenses = async () => {
    if (selectedLicenses.length === 0) {
      setOperationMessage('Please select licenses to remove');
      return;
    }

    setOperationLoading(true);
    setOperationMessage('');

    try {
      const licenseIds = selectedLicenses.map(lic => lic.id);
      console.log('Removing licenses:', licenseIds);

      // Use the deleteLicensesFromDatabase API with proper source attribution
      const result = await deleteLicensesFromDatabase(licenseIds, "UniqueUserDetails");

      if (result) {
        setOperationMessage(`Successfully removed ${selectedLicenses.length} license(s)`);

        // Refresh license data
        const licensesData = await fetchLicensesForUserId(user!.userId);
        if (licensesData) {
          setLicenses(Array.isArray(licensesData) ? licensesData : []);
        }

        // Clear selection
        setSelectedLicenses([]);
      } else {
        setOperationMessage('Failed to remove licenses');
      }
    } catch (error) {
      console.error('Error removing licenses:', error);
      setOperationMessage('Error removing licenses');
    } finally {
      setOperationLoading(false);
    }
  };

  // License History Modal functions
  const openLicenseHistoryModal = async (licenseId: number) => {
    try {
      setOperationLoading(true);
      // Fetch license history from API
      const data = await getLicenseHistory(licenseId);
      setSelectedLicenseSummary(data.summary);
      setSelectedLicenseHistory(data.history);
      setShowLicenseHistory(true);
    } catch (error) {
      console.error('Error fetching license history:', error);
      setOperationMessage('Failed to load license history');
    } finally {
      setOperationLoading(false);
    }
  };
  return (
    <div className={`p-4 transition-all duration-300 ease-in-out ${isSidebarOpen ? 'ml-64' : 'ml-16'} ${useNew ? 'font-plex' : ''}`}>
    {/* Page Header */}
    <div className={useNew
      ? "flex justify-center mb-4 bg-surface-raised border border-border-subtle py-4 rounded"
      : "flex justify-center mb-4 bg-gradient-to-r from-gray-50 to-blue-50 py-4 rounded-lg"
    }>
      <h1 className={useNew ? "text-2xl font-bold text-center text-ink-primary" : "text-2xl font-bold text-center text-gray-800"}>{t.userLicenseDashboard}</h1>
    </div>

    {loading ? (
      <div className="flex justify-center items-center h-32">
        <p className={useNew ? "text-ink-secondary" : "text-gray-600"}>Loading user details...</p>
      </div>
    ) : user ? (
      /* Compact User Info Section - Full Width Cards */
      <div className="grid gap-2 mb-4" style={{gridTemplateColumns: '1fr 0.5fr 0.5fr'}}>
        {/* User Identifiers Card - allow up to 1/3 width */}
        <div className={useNew
          ? "bg-surface border border-border-subtle rounded-lg p-2 flex-1"
          : "bg-gradient-to-br from-green-50 to-emerald-100 border border-green-200 rounded-xl p-2 shadow-md flex-1"
        }>
          <div className="flex items-center gap-2 mb-2">
            <div className={useNew
              ? "w-2 h-7 bg-accent rounded-full flex items-center justify-center"
              : "w-2 h-7 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center"
            }>
              <i className="pi pi-user text-white text-base"></i>
            </div>
            <span className={useNew ? "text-lg font-bold text-ink-primary" : "text-lg font-bold text-green-900"}>{t.userIdentifiers}</span>
          </div>

          {/* User Identifiers - Enhanced Display */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className={useNew
              ? "p-3 bg-surface border border-border-subtle rounded-lg flex flex-col gap-1.5"
              : "p-3 bg-white border border-green-200 rounded-lg shadow-sm flex flex-col gap-1.5"
            }>
              <div className={useNew
                ? "w-2 h-6 bg-accent/10 rounded-full flex items-center justify-center self-start"
                : "w-2 h-6 bg-indigo-100 rounded-full flex items-center justify-center self-start"
              }>
                <i className={useNew ? "pi pi-envelope text-accent text-sm" : "pi pi-envelope text-indigo-600 text-sm"}></i>
              </div>
              <p className={useNew ? "text-xs text-ink-secondary font-medium" : "text-xs text-gray-600 font-medium"}>Email Address</p>
              <p
                className={useNew ? "text-sm font-semibold text-ink-primary break-all whitespace-normal" : "text-sm font-semibold text-gray-900 break-all whitespace-normal"}
                title={user.email}
              >
                {user.email || "N/A"}
              </p>
            </div>

            <div className={useNew
              ? "p-3 bg-surface border border-border-subtle rounded-lg flex flex-col gap-1.5"
              : "p-3 bg-white border border-green-200 rounded-lg shadow-sm flex flex-col gap-1.5"
            }>
              <div className={useNew
                ? "w-3 h-6 bg-accent/10 rounded-full flex items-center justify-center self-start"
                : "w-3 h-6 bg-purple-100 rounded-full flex items-center justify-center self-start"
              }>
                <i className={useNew ? "pi pi-id-card text-accent text-sm" : "pi pi-id-card text-purple-600 text-sm"}></i>
              </div>
              <p className={useNew ? "text-xs text-ink-secondary font-medium" : "text-xs text-gray-600 font-medium"}>{user.userIds && user.userIds.length > 1 ? 'Login IDs' : 'User ID'}</p>
              <p className={useNew ? "text-sm font-semibold text-ink-primary break-all whitespace-normal flex flex-wrap items-center gap-1" : "text-sm font-semibold text-gray-900 break-all whitespace-normal flex flex-wrap items-center gap-1"}>
                {(user.userIds && user.userIds.length > 0 ? user.userIds : user.userId ? [user.userId] : []).length > 0
                  ? (user.userIds && user.userIds.length > 0 ? user.userIds : [user.userId!]).map((uid, idx) => {
                      const isMultiple = userIdsWithMultipleEmails.includes(uid);
                      return (
                        <span key={uid}>
                          {idx > 0 && ', '}
                          <span
                            className={isMultiple ? (useNew ? 'text-warning font-semibold' : 'text-amber-600 font-semibold') : ''}
                            title={isMultiple ? 'This user-id is linked to more than one email (unique user).' : undefined}
                          >
                            {uid}
                          </span>
                          {isMultiple && (
                            <i className={useNew ? "pi pi-exclamation-triangle text-warning ml-0.5" : "pi pi-exclamation-triangle text-amber-600 ml-0.5"} title="Linked to multiple emails" aria-hidden />
                          )}
                        </span>
                      );
                    })
                  : 'N/A'}
              </p>
            </div>

            <div className={useNew
              ? "p-3 bg-surface border border-border-subtle rounded-lg flex flex-col gap-1.5"
              : "p-3 bg-white border border-green-200 rounded-lg shadow-sm flex flex-col gap-1.5"
            }>
              <div className={useNew
                ? "w-6 h-6 bg-accent/10 rounded-full flex items-center justify-center self-start"
                : "w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center self-start"
              }>
                <i className={useNew ? "pi pi-hashtag text-accent text-sm" : "pi pi-hashtag text-orange-600 text-sm"}></i>
              </div>
              <p className={useNew ? "text-xs text-ink-secondary font-medium" : "text-xs text-gray-600 font-medium"}>System ID</p>
              <p
                className={useNew ? "text-sm font-semibold text-ink-primary break-all whitespace-normal" : "text-sm font-semibold text-gray-900 break-all whitespace-normal"}
                title={user.sid}
              >
                {user.sid || "N/A"}
              </p>
            </div>
          </div>
        </div>

        {/* Associated Servers Card */}
        <div className={useNew
          ? "bg-surface border border-border-subtle rounded-lg p-2 flex-1"
          : "bg-blue-50 border-2 border-blue-200 rounded-lg p-2 flex-1"
        }>
          <div className="flex items-center gap-2 mb-2">
            <i className={useNew ? "pi pi-server text-accent text-lg" : "pi pi-server text-blue-600 text-lg"}></i>
            <span className={useNew ? "text-base font-semibold text-ink-primary" : "text-base font-semibold text-blue-900"}>{t.associatedServers}</span>
          </div>
          <div className={useNew
            ? "text-sm text-ink-primary break-words bg-surface p-2 rounded border border-border-subtle"
            : "text-sm text-gray-900 break-words bg-white p-2 rounded border shadow-sm"
          }>
            {user.servers ? (
              <div className="max-h-16 overflow-y-auto">
                {user.servers}
              </div>
            ) : (
              <span className={useNew ? "text-ink-secondary italic text-xs" : "text-gray-500 italic text-xs"}>No server associations</span>
            )}
          </div>
          {user.remarks && (
            <div className={useNew ? "mt-2 pt-2 border-t border-border-subtle" : "mt-2 pt-2 border-t-2 border-blue-200"}>
              <div className="flex items-center gap-2 mb-2">
                <p className={useNew ? "text-sm font-semibold text-ink-primary whitespace-nowrap" : "text-sm font-semibold text-blue-800 whitespace-nowrap"}>Name:</p>
                <p className={useNew ? "text-sm font-semibold text-ink-primary" : "text-sm font-semibold text-gray-900"}>{user.fullName || user.userDetails || 'N/A'}</p>
              </div>
              <div className="flex items-center gap-2">
                <p className={useNew ? "text-sm font-semibold text-ink-primary whitespace-nowrap" : "text-sm font-semibold text-blue-800 whitespace-nowrap"}>Remarks:</p>
                <p className={useNew ? "text-sm text-ink-primary leading-relaxed bg-surface-raised p-2 rounded flex-1" : "text-sm text-gray-900 leading-relaxed bg-gray-50 p-2 rounded flex-1"}>{user.remarks}</p>
              </div>
            </div>
          )}
        </div>

        {/* Additional Info & Stats Card */}
        <div className={useNew ? "bg-surface-raised border border-border-subtle rounded-lg p-4" : "bg-gray-50 border border-gray-200 rounded-lg p-4"}>
          <div className="space-y-4">
            {/* Quick Stats */}
            <div className="flex items-center gap-6">
              <div className="text-center">
                <div className={useNew ? "text-lg font-bold text-accent" : "text-lg font-bold text-blue-600"}>{licenses.length}</div>
                <div className={useNew ? "text-xs text-ink-secondary" : "text-xs text-gray-600"}>Licenses</div>
              </div>
              <div className="text-center">
                <div className={useNew
                  ? `text-sm font-medium px-2 py-1 rounded-full mb-1 ${
                      user.status === 'Active' ? 'bg-success/10 text-success' :
                      user.status === 'Disabled' ? 'bg-danger/10 text-danger' :
                      'bg-surface text-ink-secondary'
                    }`
                  : `text-sm font-medium px-2 py-1 rounded-full mb-1 ${
                      user.status === 'Active' ? 'bg-green-100 text-green-800' :
                      user.status === 'Disabled' ? 'bg-red-100 text-red-800' :
                      'bg-gray-100 text-gray-800'
                    }`
                }>
                  {user.status || "Unknown"}
                </div>
                <div className={useNew ? "text-xs text-ink-secondary" : "text-xs text-gray-600"}>Status</div>
              </div>
            </div>

            {/* Additional Information */}
            <div className={useNew ? "border-t border-border-subtle pt-4" : "border-t pt-4"}>
              <div className="grid grid-cols-1 gap-4">
                <div className="text-center">
                  <i className={useNew ? "pi pi-phone text-ink-secondary text-xl mb-2 block" : "pi pi-phone text-gray-600 text-xl mb-2 block"}></i>
                  <p className={useNew ? "text-sm text-ink-secondary font-medium" : "text-sm text-gray-600 font-medium"}>Mobile</p>
                  <p className={useNew ? "text-lg font-semibold text-ink-primary" : "text-lg font-semibold text-gray-900"}>{user.mobile || "N/A"}</p>
                </div>
                <div className="text-center">
                  <i className={useNew ? "pi pi-calendar text-ink-secondary text-xl mb-2 block" : "pi pi-calendar text-gray-600 text-xl mb-2 block"}></i>
                  <p className={useNew ? "text-sm text-ink-secondary font-medium" : "text-sm text-gray-600 font-medium"}>Created</p>
                  <p className={useNew ? "text-base font-semibold text-ink-primary" : "text-base font-semibold text-gray-900"}>{new Date(user.createdAt).toLocaleDateString()}</p>
                </div>
              </div>
            </div>

            {/* Workspace NFS Home (IC-040) — currently backed by simulated IPA/NFS stubs */}
            <div className={useNew ? "border-t border-border-subtle pt-4" : "border-t pt-4"}>
              <div className="text-center">
                <i className={useNew ? "pi pi-folder text-ink-secondary text-xl mb-2 block" : "pi pi-folder text-gray-600 text-xl mb-2 block"}></i>
                <p className={useNew ? "text-sm text-ink-secondary font-medium mb-1" : "text-sm text-gray-600 font-medium mb-1"}>Workspace Home</p>
                {user.homeReady ? (
                  <>
                    <p className={useNew ? "text-sm font-semibold text-success" : "text-sm font-semibold text-green-700"}>Ready</p>
                    <p className={useNew ? "text-xs text-ink-secondary mt-1" : "text-xs text-gray-500 mt-1"}>{user.homePath}</p>
                  </>
                ) : (
                  <p className={useNew ? "text-xs text-ink-secondary mb-2" : "text-xs text-gray-500 mb-2"}>Not provisioned yet</p>
                )}
                <Button
                  label={user.homeReady ? "Re-generate NFS Home" : "Generate NFS Home"}
                  icon="pi pi-folder-open"
                  className={useNew ? "px-3 py-1.5 mt-2 bg-accent text-white text-sm font-medium rounded-full shadow-sm hover:opacity-90 transition-all duration-200 border-0" : "p-button-sm p-button-rounded mt-2"}
                  onClick={handleGenerateNfsHome}
                  loading={nfsHomeLoading}
                  disabled={nfsHomeLoading}
                />
                {nfsHomeMessage && (
                  <p className={useNew ? "text-xs text-ink-secondary mt-2" : "text-xs text-gray-500 mt-2"}>{nfsHomeMessage}</p>
                )}
              </div>
            </div>

            {/* Legacy VNC session bridge (IC-041) — IC-owned, not via IWM */}
            <div className={useNew ? "border-t border-border-subtle pt-4" : "border-t pt-4"}>
              <div className="text-center">
                <i className={useNew ? "pi pi-desktop text-ink-secondary text-xl mb-2 block" : "pi pi-desktop text-gray-600 text-xl mb-2 block"}></i>
                <p className={useNew ? "text-sm text-ink-secondary font-medium mb-2" : "text-sm text-gray-600 font-medium mb-2"}>Legacy VNC Session</p>
                <Button
                  label="Open VNC Session"
                  icon="pi pi-external-link"
                  className={useNew ? "px-3 py-1.5 bg-accent text-white text-sm font-medium rounded-full shadow-sm hover:opacity-90 transition-all duration-200 border-0" : "p-button-sm p-button-rounded"}
                  onClick={() => window.open(`/#/vnc-viewer/${user.userId}`, '_blank')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div className="flex justify-center items-center h-32">
        <p className={useNew ? "text-ink-secondary" : "text-gray-600"}>User not found</p>
      </div>
    )}



    {/* Operation Status Messages */}
    {operationMessage && (
      <div className={useNew
        ? `mb-4 p-4 rounded-lg border ${
            operationMessage.includes('success') || operationMessage.includes('Successfully')
              ? 'bg-success/10 border-success/30 text-success'
              : operationMessage.includes('Error') || operationMessage.includes('Failed')
              ? 'bg-danger/10 border-danger/30 text-danger'
              : 'bg-info/10 border-info/30 text-info'
          }`
        : `mb-4 p-4 rounded-lg shadow-sm ${
            operationMessage.includes('success') || operationMessage.includes('Successfully')
              ? 'bg-green-100 border-2 border-green-300 text-green-800'
              : operationMessage.includes('Error') || operationMessage.includes('Failed')
              ? 'bg-red-100 border-2 border-red-300 text-red-800'
              : 'bg-blue-100 border-2 border-blue-300 text-blue-800'
          }`
      }>
        <div className="flex items-center gap-2">
          <i className={useNew
            ? `pi ${
                operationMessage.includes('success') || operationMessage.includes('Successfully')
                  ? 'pi-check-circle text-success'
                  : operationMessage.includes('Error') || operationMessage.includes('Failed')
                  ? 'pi-times-circle text-danger'
                  : 'pi-info-circle text-info'
              } text-lg`
            : `pi ${
                operationMessage.includes('success') || operationMessage.includes('Successfully')
                  ? 'pi-check-circle text-green-600'
                  : operationMessage.includes('Error') || operationMessage.includes('Failed')
                  ? 'pi-times-circle text-red-600'
                  : 'pi-info-circle text-blue-600'
              } text-lg`
          }></i>
          <span className="font-semibold">{operationMessage}</span>
        </div>
      </div>
    )}

    {/* Current License Allocations */}
    <div className={useNew ? "mt-4 bg-surface-raised border border-border-subtle p-4 rounded-lg" : "mt-4 bg-gradient-to-r from-green-50 to-blue-50 p-4 rounded-lg"}>

      {licenses.length > 0 ? (
        <>
          {/* Selected License Operations */}
          {selectedLicenses.length > 0 && (
            <div className={useNew
              ? "mb-4 p-4 bg-accent/5 border border-accent/20 rounded-lg"
              : "mb-4 p-4 bg-yellow-50 border-2 border-yellow-300 rounded-lg shadow-sm"
            }>
              <h3 className={useNew ? "text-sm font-semibold text-ink-primary mb-2 flex items-center gap-2" : "text-sm font-semibold text-yellow-800 mb-2 flex items-center gap-2"}>
                <i className="pi pi-check-square"></i>
                Operations for Selected Licenses ({selectedLicenses.length})
              </h3>
              <p className={useNew ? "text-xs text-ink-secondary mb-3" : "text-xs text-gray-600 mb-3"}>
                Apply bulk operations to the {selectedLicenses.length} selected license{selectedLicenses.length > 1 ? 's' : ''} below
              </p>
              <div className="flex flex-wrap items-center gap-2">
                <Button
                  label={t.disableSelectedUsers}
                  icon="pi pi-ban"
                  className={useNew ? "px-3 py-1.5 bg-danger text-white text-sm font-medium rounded-full shadow-sm hover:opacity-90 transition-all duration-200 border-0" : "p-button-danger p-button-sm p-button-rounded"}
                  onClick={handleDisableLicenses}
                  loading={operationLoading}
                  disabled={operationLoading}
                />
                <Button
                  label={t.enableSelectedUsers}
                  icon="pi pi-check"
                  className={useNew ? "px-3 py-1.5 bg-success text-white text-sm font-medium rounded-full shadow-sm hover:opacity-90 transition-all duration-200 border-0" : "p-button-success p-button-sm p-button-rounded"}
                  onClick={handleEnableLicenses}
                  loading={operationLoading}
                  disabled={operationLoading}
                />
                <div className="flex items-center gap-2">
                  <Button
                    label={t.requestExtensionUsers}
                    icon="pi pi-calendar-plus"
                    className={useNew ? "px-3 py-1.5 bg-warning text-white text-sm font-medium rounded-full shadow-sm hover:opacity-90 transition-all duration-200 border-0" : "p-button-warning p-button-sm p-button-rounded"}
                    onClick={handleRequestExtension}
                    disabled={operationLoading}
                  />
                </div>
                <Button
                  label={t.removeSelectedUsers}
                  icon="pi pi-trash"
                  className={useNew ? "px-3 py-1.5 bg-danger text-white text-sm font-medium rounded-full shadow-sm hover:opacity-90 transition-all duration-200 border-0" : "p-button-danger p-button-sm p-button-rounded"}
                  onClick={handleRemoveLicenses}
                  loading={operationLoading}
                  disabled={operationLoading}
                />
              </div>
            </div>
          )}

          {/* License Table */}
          <div className={useNew ? "bg-surface border border-border-subtle rounded-lg overflow-hidden" : "bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden"}>
            <div className={useNew ? "p-4 border-b border-border-subtle bg-surface-raised" : "p-4 border-b border-gray-200 bg-gray-50"}>
              <h3 className={useNew ? "text-lg font-semibold text-ink-primary flex items-center gap-2" : "text-lg font-semibold text-gray-800 flex items-center gap-2"}>
                <i className={useNew ? "pi pi-list text-ink-secondary" : "pi pi-list text-gray-600"}></i>
                License Details
                <span className={useNew ? "text-sm font-normal text-ink-secondary" : "text-sm font-normal text-gray-600"}>({licenses.length} total)</span>
              </h3>
              <p className={useNew ? "text-sm text-ink-secondary mt-1" : "text-sm text-gray-600 mt-1"}>
                Select licenses using checkboxes to perform bulk operations
              </p>
            </div>

            <DataTable
              value={licenses}
              paginator
              rows={10}
              selectionMode="multiple"
              selection={selectedLicenses}
              onSelectionChange={(e) => setSelectedLicenses(e.value)}
              className="p-datatable-sm"
              stripedRows
            >
              <Column selectionMode="multiple" headerStyle={{ width: '3em' }} bodyStyle={{ textAlign: 'center' }} />
              <Column
                field="id"
                header="ID"
                sortable
                style={{ width: '80px' }}
                body={(rowData) => (
                  <button
                    className={useNew ? "text-accent hover:text-accent-hover underline" : "text-blue-600 hover:text-blue-800 underline"}
                    onClick={(e) => {
                      e.stopPropagation();
                      openLicenseHistoryModal(rowData.id);
                    }}
                  >
                    {rowData.id}
                  </button>
                )}
              />
              <Column field="toolName" header="Tool" sortable style={{ width: '120px' }} />
              <Column field="licenseCount" header="Count" sortable style={{ width: '80px', textAlign: 'center' }} />
              <Column
                field="status"
                header="Status"
                sortable
                style={{ width: '100px' }}
                body={(rowData) => (
                  <span className={useNew
                    ? `px-2 py-1 rounded-full text-xs font-medium ${
                        rowData.status === 'Active' ? 'bg-success/10 text-success' :
                        rowData.status === 'Disabled' ? 'bg-danger/10 text-danger' :
                        'bg-surface-raised text-ink-secondary'
                      }`
                    : `px-2 py-1 rounded-full text-xs font-medium ${
                        rowData.status === 'Active' ? 'bg-green-100 text-green-800' :
                        rowData.status === 'Disabled' ? 'bg-red-100 text-red-800' :
                        'bg-gray-100 text-gray-800'
                      }`
                  }>
                    {rowData.status || 'Unknown'}
                  </span>
                )}
              />
              <Column field="source" header="Source" sortable style={{ width: '120px' }} body={(rowData) => rowData.source || "N/A"} />
              <Column field="serverInfo" header="Server" sortable style={{ width: '150px' }} />
              <Column
                field="startDate"
                header="Start Date"
                sortable
                style={{ width: '140px' }}
                body={(rowData) => rowData.startDate ? new Date(rowData.startDate).toLocaleDateString() : "N/A"}
              />
              <Column
                field="endDate"
                header="End Date"
                sortable
                style={{ width: '140px' }}
                body={(rowData: LicenseTransactionEntity) => {
                  // Show plannedEndDate for active licenses, endDate for expired licenses
                  const displayDate = rowData.status === 'Expired'
                    ? rowData.endDate
                    : rowData.plannedEndDate;
                  return displayDate ? new Date(displayDate).toLocaleDateString() : 'No expiry set';
                }}
              />
              <Column
                field="createdAt"
                header="Created"
                sortable
                style={{ width: '140px' }}
                body={(rowData) => new Date(rowData.createdAt).toLocaleDateString()}
              />
            </DataTable>
          </div>
        </>
      ) : (
        <div className={useNew
          ? "bg-surface border-2 border-dashed border-border-subtle rounded-lg p-8 text-center"
          : "bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-8 text-center"
        }>
          <i className={useNew ? "pi pi-inbox text-ink-secondary text-4xl mb-4" : "pi pi-inbox text-gray-400 text-4xl mb-4"}></i>
          <h3 className={useNew ? "text-lg font-medium text-ink-primary mb-2" : "text-lg font-medium text-gray-700 mb-2"}>No Licenses Found</h3>
          <p className={useNew ? "text-ink-secondary" : "text-gray-500"}>This user doesn't have any license allocations yet.</p>
          <p className={useNew ? "text-sm text-ink-secondary mt-2" : "text-sm text-gray-400 mt-2"}>Use the "Add Licenses" section above to allocate licenses.</p>
        </div>
      )}
    </div>

    {/* Add New Licenses - After License Table */}
    <div className={useNew ? "mt-4 w-full bg-surface-raised border border-border-subtle p-4 rounded-lg" : "mt-4 w-full bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg"}>
      <div className={useNew ? "bg-surface border border-border-subtle rounded-lg p-6" : "bg-white border-2 border-blue-300 rounded-xl shadow-lg p-6"}>
        {/* Add New Licenses */}
        <div className={useNew ? "p-4 bg-surface-raised border border-border-subtle rounded-lg" : "p-4 bg-blue-50 border border-blue-200 rounded-lg"}>
          <h4 className={useNew ? "text-base font-semibold text-ink-primary mb-3 flex items-center gap-2" : "text-base font-semibold text-blue-800 mb-3 flex items-center gap-2"}>
            <i className={useNew ? "pi pi-plus-circle text-accent" : "pi pi-plus-circle text-blue-600"}></i>
            Add New Licenses for {user?.userDetails || user?.email}
          </h4>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 items-end">
            <div className="flex flex-col">
              <label className={useNew ? "text-sm font-medium text-ink-secondary mb-2" : "text-sm font-medium text-gray-700 mb-2"}>Select Tools</label>
              <MultiSelect
                value={selectedTools}
                placeholder={toolsLoading ? "Loading tools..." : "Choose tools"}
                options={tools}
                display="chip"
                onChange={(e) => {
                  console.log('Tools selected:', e.value);
                  setSelectedTools(e.value);
                }}
                className="w-full"
                maxSelectedLabels={2}
                showClear
                disabled={toolsLoading}
                loading={toolsLoading}
              />
            </div>

            <div className="flex flex-col">
              <label className={useNew ? "text-sm font-medium text-ink-secondary mb-2" : "text-sm font-medium text-gray-700 mb-2"}>License Count</label>
              <InputNumber
                value={numLicenses}
                onValueChange={(e) => {
                  if (e.value !== null && e.value !== undefined) {
                    setNumLicenses(e.value);
                  }
                }}
                min={1}
                max={10}
                showButtons
                buttonLayout="vertical"
                className="w-full"
              />
            </div>

            <div className="flex flex-col">
              <label className={useNew ? "text-sm font-medium text-ink-secondary mb-2" : "text-sm font-medium text-gray-700 mb-2"}>License Server</label>
              <Dropdown
                value={selectedLicServer}
                options={licenseServers.map((server) => ({
                  label: `${server.serverFqdn}:${server.servicePort}`,
                  value: `${server.serverFqdn}:${server.servicePort}`
                }))}
                onChange={(e) => {
                  console.log('License server selected:', e.value);
                  setSelectedLicServer(e.value);
                }}
                placeholder="Select License Server"
                className="w-full"
                showClear
              />
            </div>

            <div className="flex flex-col">
              <label className={useNew ? "text-sm font-medium text-ink-secondary mb-2" : "text-sm font-medium text-gray-700 mb-2"}>Target Server</label>
              <Dropdown
                value={selectedServer}
                options={infraServers.map((server) => ({
                  label: server.serverInfo,
                  value: server.serverInfo
                }))}
                onChange={(e) => {
                  console.log('Target server selected:', e.value);
                  setSelectedServer(e.value);
                }}
                placeholder="Select Target Server"
                className="w-full"
                showClear
              />
            </div>

            <div className="flex flex-col">
              <label className={useNew ? "text-sm font-medium text-ink-secondary mb-2" : "text-sm font-medium text-gray-700 mb-2"}>License End Date</label>
              <Calendar
                value={licenseEndDate}
                onChange={(e) => {
                  console.log('License end date selected:', e.value);
                  setLicenseEndDate(e.value || null);
                }}
                placeholder="Select End Date"
                className="w-full"
                showIcon
                dateFormat="dd/mm/yy"
                minDate={new Date()}
              />
            </div>

            <div className="flex flex-col">
              <label className={useNew ? "text-sm font-medium text-ink-secondary mb-2 opacity-0" : "text-sm font-medium text-gray-700 mb-2 opacity-0"}>Action</label>
              <Button
                label="Add Licenses"
                icon="pi pi-plus"
                className={useNew ? "px-4 py-2 bg-accent text-white font-medium rounded-lg shadow-sm hover:bg-accent-hover transition-all duration-200 border-0 w-full" : "p-button-primary p-button-lg w-full"}
                disabled={addLicenseLoading || selectedTools.length === 0 || !selectedLicServer || !selectedServer}
                onClick={() => {
                  if (selectedTools.length === 0) {
                    console.error("No tools selected");
                    return;
                  }
                  if (!user) {
                    console.error("No user selected");
                    return;
                  }
                  if (!selectedLicServer) {
                    console.error("No license server selected");
                    return;
                  }
                  if (!selectedServer) {
                    console.error("No target server selected");
                    return;
                  }
                  // ✅ REMOVED: licenseEndDate validation - always has 90-day default

                  // ✅ Show loading indicator immediately (urgent update)
                  setAddLicenseLoading(true);
                  setAddLicenseMessage(`Adding ${selectedTools.length} license${selectedTools.length > 1 ? 's' : ''} for ${numLicenses} user${numLicenses > 1 ? 's' : ''}...`);

                  // ✅ Use setTimeout to allow React to process state updates before async operation
                  setTimeout(async () => {
                    try {
                      console.log("Adding licenses for user:", user.userId, "tools:", selectedTools, "count:", numLicenses, "licServer:", selectedLicServer, "server:", selectedServer, "endDate:", licenseEndDate);
                      const result = await addLicensesToUsers("GUI_User", {
                        users: [user],
                        tools: selectedTools,
                        numLicenses: numLicenses,
                        server: selectedServer,
                        licServer: selectedLicServer,
                        endDate: licenseEndDate!.toISOString()
                      });

                      console.log("License addition result:", result);

                      if (result.data && result.data.length > 0) {
                        result.data.forEach((item: any) => {
                          if (item.status === "success") {
                            console.log("Success:", item.message);
                          } else if (item.status === "error") {
                            console.error("Error:", item.message);
                          } else {
                            console.log("Info:", item.message);
                          }
                        });
                      }

                      // ✅ Use helper function for consistent result display
                      showResultAndHide('✅ Successfully added licenses!', true);

                      // Refresh licenses after successful addition
                      const licensesData = await fetchLicensesForUserId(user.userId);
                      if (licensesData) {
                        setLicenses(Array.isArray(licensesData) ? licensesData : []);
                      }

                      // Clear form after successful submission
                      setSelectedTools([]);
                      setNumLicenses(1);
                      setSelectedServer(null);
                      setSelectedLicServer(null);
                      setLicenseEndDate(null);

                    } catch (error) {
                      console.error("Failed to add licenses:", error);

                      // ❌ Use helper function for error display
                      showResultAndHide('❌ Failed to add licenses. Please try again.', false);
                    }
                  }, 0); // Next tick allows React to process state updates
                }}
              />
            </div>
          </div>

          {/* Selection Summary */}
          {(selectedTools.length > 0 || selectedServer || selectedLicServer || licenseEndDate) && (
            <div className={useNew ? "mt-4 p-3 bg-surface border border-border-subtle rounded-lg" : "mt-4 p-3 bg-white border border-blue-300 rounded-lg"}>
              <h5 className={useNew ? "text-sm font-semibold text-ink-primary mb-2" : "text-sm font-semibold text-blue-800 mb-2"}>License Configuration Summary</h5>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                <div>
                  <span className={useNew ? "font-medium text-ink-secondary" : "font-medium text-gray-600"}>Tools:</span>
                  <p className={useNew ? "text-accent" : "text-blue-700"}>{selectedTools.length > 0 ? selectedTools.join(', ') : 'None selected'}</p>
                </div>
                <div>
                  <span className={useNew ? "font-medium text-ink-secondary" : "font-medium text-gray-600"}>Count:</span>
                  <p className={useNew ? "text-accent" : "text-blue-700"}>{numLicenses}</p>
                </div>
                <div>
                  <span className={useNew ? "font-medium text-ink-secondary" : "font-medium text-gray-600"}>License Server:</span>
                  <p className={useNew ? "text-accent" : "text-blue-700"}>{selectedLicServer || 'None selected'}</p>
                </div>
                <div>
                  <span className={useNew ? "font-medium text-ink-secondary" : "font-medium text-gray-600"}>Target Server:</span>
                  <p className={useNew ? "text-accent" : "text-blue-700"}>{selectedServer || 'None selected'}</p>
                </div>
                <div className="col-span-2 md:col-span-4">
                  <span className={useNew ? "font-medium text-ink-secondary" : "font-medium text-gray-600"}>End Date:</span>
                  <p className={useNew ? "text-accent" : "text-blue-700"}>{licenseEndDate ? licenseEndDate.toLocaleDateString() : 'None selected'}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>

    {/* License Server Operations - Full Width at Bottom */}
    <div className="mt-12 mb-8">
      <div className="w-full">
        <div className={useNew ? "bg-surface border border-border-strong rounded-lg p-6" : "bg-white border-2 border-orange-300 rounded-xl shadow-lg p-6"}>
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <i className={useNew ? "pi pi-server text-accent text-xl" : "pi pi-server text-orange-600 text-xl"}></i>
              <h3 className={useNew ? "text-xl font-bold text-ink-primary" : "text-xl font-bold text-orange-900"}>Server Operations</h3>
            </div>
            <div className={useNew ? "bg-warning/10 border border-warning/30 rounded-lg px-3 py-1" : "bg-yellow-100 border border-yellow-300 rounded-lg px-3 py-1"}>
              <span className={useNew ? "text-xs font-semibold text-warning" : "text-xs font-semibold text-yellow-800"}>Admin Required</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 items-center">
            <div className="flex-1">
              <Button
                label="Sync Licenses to Server"
                icon="pi pi-cog"
                className={useNew ? "px-4 py-2 bg-warning text-white font-medium rounded-lg shadow-sm hover:opacity-90 transition-all duration-200 border-0 w-full" : "p-button-warning p-button-lg w-full"}
                onClick={() => setIsModalVisible(true)}
              />
              <p className={useNew ? "text-xs text-ink-secondary mt-2" : "text-xs text-gray-600 mt-2"}>Apply database changes to license servers</p>
            </div>

            {/* Server Status */}
            <div className={useNew ? "bg-surface-raised border border-border-subtle rounded-lg p-3 text-center min-w-48" : "bg-gray-100 rounded-lg p-3 text-center min-w-48"}>
              <p className={useNew ? "text-xs text-ink-secondary font-medium" : "text-xs text-gray-600 font-medium"}>Server Status</p>
              <div className="mt-2 flex justify-center">
                <span className={useNew ? "inline-flex items-center px-2 py-1 rounded-full text-xs bg-danger/10 text-danger" : "inline-flex items-center px-2 py-1 rounded-full text-xs bg-red-100 text-red-800"}>
                  <i className={useNew ? "pi pi-circle-fill text-danger mr-1" : "pi pi-circle-fill text-red-500 mr-1"}></i>
                  Not Synced
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Server Operations Modal */}
    <Modal
      title="🔄 License Server Operations - Admin Access Required"
      open={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
      footer={[
        <Button key="cancel" onClick={() => setIsModalVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="goto"
          onClick={() => {
            setIsModalVisible(false);
            navigate('/licmgmt');
          }}
          className={useNew ? "bg-accent hover:bg-accent-hover text-white" : "bg-orange-500 hover:bg-orange-600 text-white"}
        >
          Go to License Server Administration
        </Button>
      ]}
      centered
      width={600}
    >
      <div className="py-4">
        <div className="flex items-center gap-3 mb-4">
          <i className={useNew ? "pi pi-server text-accent text-2xl" : "pi pi-server text-orange-500 text-2xl"}></i>
          <h3 className={useNew ? "text-lg font-semibold text-ink-primary" : "text-lg font-semibold text-gray-800"}>Server-Side License Operations</h3>
        </div>

        <div className={useNew ? "bg-warning/10 border border-warning/30 rounded-lg p-4 mb-4" : "bg-orange-50 border border-orange-200 rounded-lg p-4 mb-4"}>
          <h4 className={useNew ? "font-semibold text-warning mb-2" : "font-semibold text-orange-800 mb-2"}>{useNew ? 'Administrator Privileges Required' : '⚠️ Administrator Privileges Required'}</h4>
          <p className={useNew ? "text-sm text-ink-primary" : "text-sm text-gray-700"}>
            Server operations can only be performed by users with administrative access. These operations directly affect the license servers and require careful coordination.
          </p>
        </div>

        <div className="space-y-3">
          <h4 className={useNew ? "font-semibold text-ink-primary" : "font-semibold text-gray-800"}>Available Server Operations:</h4>

          <div className="grid grid-cols-1 gap-3">
            <div className={useNew ? "flex items-start gap-3 p-3 bg-surface-raised border border-border-subtle rounded-lg" : "flex items-start gap-3 p-3 bg-blue-50 border border-blue-200 rounded-lg"}>
              <i className={useNew ? "pi pi-sync text-accent mt-1" : "pi pi-sync text-blue-600 mt-1"}></i>
              <div>
                <h5 className={useNew ? "font-medium text-ink-primary" : "font-medium text-blue-800"}>Sync License Options File</h5>
                <p className={useNew ? "text-sm text-ink-secondary" : "text-sm text-gray-600"}>Apply database license changes to server configuration files</p>
              </div>
            </div>

            <div className={useNew ? "flex items-start gap-3 p-3 bg-surface-raised border border-border-subtle rounded-lg" : "flex items-start gap-3 p-3 bg-green-50 border border-green-200 rounded-lg"}>
              <i className={useNew ? "pi pi-refresh text-accent mt-1" : "pi pi-refresh text-green-600 mt-1"}></i>
              <div>
                <h5 className={useNew ? "font-medium text-ink-primary" : "font-medium text-green-800"}>Reread License Server</h5>
                <p className={useNew ? "text-sm text-ink-secondary" : "text-sm text-gray-600"}>Force license server to reload its configuration without restart</p>
              </div>
            </div>

            <div className={useNew ? "flex items-start gap-3 p-3 bg-surface-raised border border-border-subtle rounded-lg" : "flex items-start gap-3 p-3 bg-purple-50 border border-purple-200 rounded-lg"}>
              <i className={useNew ? "pi pi-cog text-accent mt-1" : "pi pi-cog text-purple-600 mt-1"}></i>
              <div>
                <h5 className={useNew ? "font-medium text-ink-primary" : "font-medium text-purple-800"}>Server Health Monitoring</h5>
                <p className={useNew ? "text-sm text-ink-secondary" : "text-sm text-gray-600"}>Check server status, license usage, and connection health</p>
              </div>
            </div>
          </div>
        </div>

        <div className={useNew ? "mt-4 p-3 bg-surface-raised border border-border-subtle rounded-lg" : "mt-4 p-3 bg-gray-50 border border-gray-200 rounded-lg"}>
          <p className={useNew ? "text-sm text-ink-primary" : "text-sm text-gray-700"}>
            <strong>Note:</strong> Database operations (adding/removing licenses) are immediately effective and don't require server synchronization.
            Server operations ensure that the actual license servers reflect the database state.
          </p>
        </div>

        <div className={useNew ? "mt-4 p-3 bg-warning/10 border border-warning/30 rounded-lg" : "mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg"}>
          <p className={useNew ? "text-sm text-warning font-medium" : "text-sm text-yellow-800 font-medium"}>
            {useNew ? <><strong>Recommendation:</strong> Perform server synchronization during maintenance windows to avoid disrupting active users.</> : <>💡 <strong>Recommendation:</strong> Perform server synchronization during maintenance windows to avoid disrupting active users.</>}
          </p>
        </div>
      </div>
    </Modal>

    {/* Extension Request Modal */}
    <Modal
      title="📅 Request License Extension"
      open={extensionModalVisible}
      onCancel={() => setExtensionModalVisible(false)}
      onOk={submitExtensionRequest}
      confirmLoading={operationLoading}
      centered
      width={500}
    >
      <div className="py-4">
        <div className="space-y-4">
          <div className="flex items-center gap-3 mb-4">
            <i className={useNew ? "pi pi-calendar text-accent text-2xl" : "pi pi-calendar text-blue-600 text-2xl"}></i>
            <div>
              <h3 className={useNew ? "text-lg font-semibold text-ink-primary" : "text-lg font-semibold text-gray-800"}>Extension Request Details</h3>
              <p className={useNew ? "text-sm text-ink-secondary" : "text-sm text-gray-600"}>
                Requesting extension for {selectedLicenses.length} selected license{selectedLicenses.length > 1 ? 's' : ''}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className={useNew ? "block text-sm font-medium text-ink-secondary mb-2" : "block text-sm font-medium text-gray-700 mb-2"}>
                New End Date *
              </label>
              <Calendar
                value={extensionDate}
                onChange={(e) => setExtensionDate(e.value || null)}
                placeholder="Select new end date"
                className="w-full"
                showIcon
                dateFormat="dd/mm/yy"
                minDate={new Date()}
                required
              />
              {extensionDate && (
                <p className={useNew ? "text-xs text-ink-secondary mt-1" : "text-xs text-gray-500 mt-1"}>
                  Selected: {extensionDate.toLocaleDateString()}
                </p>
              )}
            </div>

            <div>
              <label className={useNew ? "block text-sm font-medium text-ink-secondary mb-2" : "block text-sm font-medium text-gray-700 mb-2"}>
                Remarks (Optional)
              </label>
              <textarea
                value={extensionRemarks}
                onChange={(e) => setExtensionRemarks(e.target.value)}
                placeholder="Reason for extension request..."
                className={useNew ? "w-full p-2 border border-border-strong rounded-md focus:ring-2 focus:ring-accent focus:border-accent bg-surface text-ink-primary" : "w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"}
                rows={3}
              />
            </div>
          </div>

          <div className={useNew ? "bg-surface-raised border border-border-subtle rounded-lg p-3" : "bg-blue-50 border border-blue-200 rounded-lg p-3"}>
            <h4 className={useNew ? "text-sm font-semibold text-ink-primary mb-2" : "text-sm font-semibold text-blue-800 mb-2"}>Selected Licenses:</h4>
            <div className="space-y-1 max-h-32 overflow-y-auto">
              {selectedLicenses.map((license, index) => (
                <div key={license.id} className={useNew ? "text-sm text-ink-primary" : "text-sm text-gray-700"}>
                  • {license.toolName} (ID: {license.id})
                </div>
              ))}
            </div>
          </div>

          <div className={useNew ? "bg-warning/10 border border-warning/30 rounded-lg p-3" : "bg-yellow-50 border border-yellow-200 rounded-lg p-3"}>
            <p className={useNew ? "text-sm text-warning" : "text-sm text-yellow-800"}>
              <strong>Note:</strong> Extension requests require approval from IT administrators before taking effect.
            </p>
          </div>
        </div>
      </div>
    </Modal>

    {/* License History Modal */}
    <Modal
      title="License History"
      open={showLicenseHistory}
      onCancel={() => setShowLicenseHistory(false)}
      footer={null}
      centered
      width={900}
      style={{ maxWidth: '90vw' }}
    >
      {selectedLicenseSummary && (
        <div className="mb-6">
          <h3 className={useNew ? "text-lg font-semibold mb-4 text-ink-primary" : "text-lg font-semibold mb-4"}>License Summary</h3>
          <div className={useNew ? "grid grid-cols-2 md:grid-cols-3 gap-4 p-4 bg-surface-raised border border-border-subtle rounded-lg text-ink-primary" : "grid grid-cols-2 md:grid-cols-3 gap-4 p-4 bg-gray-50 rounded-lg"}>
            <div><strong>License ID:</strong> {selectedLicenseSummary.licenseId}</div>
            <div><strong>User:</strong> {selectedLicenseSummary.infraUser}</div>
            <div><strong>Tool:</strong> {selectedLicenseSummary.toolName}</div>
            <div><strong>License Count:</strong> {selectedLicenseSummary.numLicenses}</div>
            <div><strong>License Server:</strong> {selectedLicenseSummary.licSrvrConnectStr}</div>
            <div><strong>Start Date:</strong> {new Date(selectedLicenseSummary.initialStartDate).toLocaleDateString()}</div>
            <div><strong>Current End Date:</strong> {new Date(selectedLicenseSummary.currentPlannedEndDate).toLocaleDateString()}</div>
            <div><strong>Extensions:</strong> {selectedLicenseSummary.numExtensions}</div>
            <div><strong>Total Extension Days:</strong> {selectedLicenseSummary.totalExtensionDays}</div>
            <div><strong>Last Updated:</strong> {new Date(selectedLicenseSummary.lastUpdated).toLocaleString()}</div>
          </div>
        </div>
      )}

      <div>
        <h3 className={useNew ? "text-lg font-semibold mb-4 text-ink-primary" : "text-lg font-semibold mb-4"}>State History Timeline</h3>
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {selectedLicenseHistory.map((entry: any, index: number) => (
            <div key={entry.id} className={useNew ? "border border-border-subtle rounded-lg p-4 bg-surface" : "border rounded-lg p-4 bg-white"}>
              <div className="flex justify-between items-start mb-2">
                <div className="flex items-center gap-2">
                  <span className={useNew ? "font-medium text-ink-primary" : "font-medium"}>#{entry.id}</span>
                  <span className={useNew ? "text-sm text-ink-secondary" : "text-sm text-gray-500"}>
                    {new Date(entry.changed_at).toLocaleString()}
                  </span>
                </div>
                <span className={useNew
                  ? `px-2 py-1 rounded text-xs font-medium ${
                      entry.old_state === entry.new_state
                        ? 'bg-info/10 text-info'
                        : 'bg-success/10 text-success'
                    }`
                  : `px-2 py-1 rounded text-xs font-medium ${
                      entry.old_state === entry.new_state
                        ? 'bg-blue-100 text-blue-800'
                        : 'bg-green-100 text-green-800'
                    }`
                }>
                  {entry.old_state || 'Created'} → {entry.new_state}
                </span>
              </div>

              {entry.change_reason && (
                <div className={useNew ? "text-sm text-ink-primary mb-2" : "text-sm text-gray-700 mb-2"}>
                  <strong>Details:</strong> {entry.change_reason}
                </div>
              )}

              <div className={useNew ? "text-xs text-ink-secondary" : "text-xs text-gray-500"}>
                <strong>Operator:</strong> {entry.operator || 'System'}
                {entry.start_date && (
                  <> | <strong>Start:</strong> {new Date(entry.start_date).toLocaleDateString()}</>
                )}
                {entry.planned_end_date && (
                  <> | <strong>Planned End:</strong> {new Date(entry.planned_end_date).toLocaleDateString()}</>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>

    {/* License Addition Loading Overlay */}
    {addLicenseLoading && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className={useNew ? "bg-surface p-8 rounded-lg shadow-xl max-w-md w-full mx-4 border border-border-subtle" : "bg-white p-8 rounded-lg shadow-xl max-w-md w-full mx-4"}>
          <div className="flex items-center space-x-4">
            <div className={useNew ? "animate-spin rounded-full h-12 w-12 border-b-4 border-accent" : "animate-spin rounded-full h-12 w-12 border-b-4 border-blue-600"}></div>
            <div className="flex-1">
              <h3 className={useNew ? "text-xl font-semibold text-ink-primary" : "text-xl font-semibold text-gray-900"}>Adding Licenses</h3>
              <p className={useNew ? "text-ink-secondary mt-1" : "text-gray-600 mt-1"}>{addLicenseMessage}</p>
              <p className={useNew ? "text-sm text-ink-secondary mt-2" : "text-sm text-gray-500 mt-2"}>Please wait while we process your request...</p>
            </div>
          </div>
        </div>
      </div>
    )}

    </div>
  );
};
